<template>
  <div class="container">
    <div class="header-container">
      <div class="btn-back"  @click="goBack"/>
      <div class="wel">
        <img class="ic" src="@/assets/img/ic_HouseTypeOption_home@2x.png"/>
        <span>欢迎回家！</span>
      </div>
    </div>
    <div class="content-container">
      <div class="info">
        <div class="item left">
          <div class="name">
            {{ buildingsInfo.buildings_name_data || buildingsInfo.buildings_name }} <br>
            {{ buildingsInfo.config_name_data || buildingsInfo.config_name }}
          </div>
          <img class="ic" src="@/assets/img/ic_HouseTypeList_eidt.png" @click="jumpToNowHousesList"/>
        </div>
        <div class="line"/>
        <div class="item right" v-if="buildingsInfo.house_name || buildingsInfo.proportion || buildingsInfo.bedroom">
          <div class="name">{{ buildingsInfo.house_name }}</div>
          <div>· {{ buildingsInfo.proportion }}</div>
          <div>· {{ buildingsInfo.bedroom }}</div>
          <img @click="isShowHouseTypeImage=!isShowHouseTypeImage" class="ic" src="@/assets/img/ic_HouseTypeList_house.png"/>
        </div>
      </div>
      <div v-if="!isShowHouseTypeImage">
        <div class="title">
          <span>魔方屋为您量身定制了</span>
          <span class="num">{{ buildingsList.length }}</span>
          <span>套梦想屋</span>
        </div>
        <div class="list">
          <div class="item" v-for="(item,index) in buildingsList" :key="index" @click="jumpToVideo(item)">
            <img class="bg" :src="imgDomain + item.img_src"/>
            <div class="main">
              <div class="name">{{item.name}}</div>
              <div v-for="(itemN,indexN) in item.label_list" :key="indexN">{{ itemN }}</div>
            </div>
          </div>
          <div class="emptyListHint" v-if="buildingsList.length == 0">
            <img src="@/assets/img/house_case_list/paper.png" alt="empty">
            <div class="txt1">很抱歉，您选择的户型暂时没有相关设计案例</div>
            <div class="txt2">您可以浏览本楼盘其它户型设计方案</div>
            <div class="btn" @click="toHouseTypeList(buildingsInfo.buildings_id)">立即查看</div>
          </div>
        </div>
      </div>
      <div v-else>
        <img class="type-img" :src="imgDomain + buildingsInfo.img_src"/>
      </div>
    </div>

    <EventPop></EventPop> <!-- 判断是否符合活动要求弹窗 -->

  </div>
</template>

<script>
  import {getUnitDecorates, getHouseDecorates} from '@/api/api.js'
  import EventPop from "../../component/EventPop"
  import utils from "../../jslib/utils"
  import {appDomain, domain, imgDomain} from "../../jslib/env"

  export default {
    components: {EventPop},
    data() {
      return {
        id: undefined,
        isShowHouseTypeImage: false,
        buildingsInfo: {},
        buildingsList: [],
      };
    },
    created() {
      this.setToken()
    },
    mounted() {
      let {house_id, id, config_id} = this.$route.query
      this.house_id = typeof house_id === 'object' ? house_id[house_id.length-1] : house_id
      this.id = typeof id === 'object' ? id[id.length-1] : id
      this.config_id = config_id
      this.hideMyHomeInsidePageHead({showFrom: ['/houseTypeList', '/houseTypeOption']}) // 从“我家”进入时隐藏头部
      if (this.house_id){
        this.network().getHouseDecorates(()=>{ if (this.id) this.network().getUnitDecorates() })
      } else if (this.id){
        this.network().getUnitDecorates()
      }
    },
    methods: {
      toSurvey(){
        this.navigateTo('survey')
      },
      toLocation(){
        this.navigateTo('myHomeInit')
      },
      noticedAboutGifts(){
        localStorage.noticedGiftsUser = utils.getCookie('user_id')
      },
      toHouseTypeList(id){
        this.navigateTo('HouseTypeList?buildings_id='+id)
      },
      toMyGiftsList(){
        this.noticedAboutGifts()
        this.jumpToMyGiftsList()
      },
      jumpToVideo(item){
        let {config_name_data, config_name, buildings_name, house_name, img_src} = this.buildingsInfo
        let title = '' + (buildings_name+' '||'') + (house_name+' '||'') + (item.name+' '||''),
          desc = item.label_list.join(' '),
          picUrl = imgDomain + item.img_src

        let idOrHouseId = this.id ? '&id='+this.id : (this.house_id ? '&house_id='+this.house_id : '')

        if(utils.getEnv() === 'web'){
          this.navigateTo('video' +
            '?video='+imgDomain+item.video+
            '&shapespark_url='+item.shape_spark_url+
            '&title='+title+
            '&config_name_data='+(config_name_data || config_name)+
            '&program_id='+item.program_id+idOrHouseId)
        }else { // app
          this.jumpShapesparkActivity(
            item.video,
            item.shape_spark_url,
            'HouseCaseDetail?program_id='+item.program_id+'&config_name_data='+(config_name_data || config_name),
            {
              title,
              desc,
              url: appDomain+'video?video='+imgDomain+item.video+'&shapespark_url='+item.shape_spark_url+'&title='+title.split(' ').join('+')+'&program_id='+item.program_id+idOrHouseId,
              picUrl
            }
          )
        }

      },
      network() {
        return {
          getUnitDecorates: async () => {
            const {id} = this
            let {data} = await getUnitDecorates({id})
            console.log('根据分类id查询推荐案例', data)
            this.buildingsInfo = data.data.buildings_list.info
            this.buildingsList = data.data.buildings_list.list
          },
          getHouseDecorates: async callback => {
            const {house_id, config_id} = this
            let {data} = await getHouseDecorates({house_id, config_id})
            console.log('根据户型id查询推荐案例', data)
            this.buildingsInfo = data.data.buildings_list.info
            this.buildingsList = data.data.buildings_list.list
            if(data) callback && callback()
          }
        };
      },
      handler() {
        return {
          example: () => {
            console.log('handle');
          },
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .header-container {
    display: flex;
    .wel {
      margin-top: .44rem;
      margin-left: auto;
      font-size: 0.42rem;
      .ic {
        width: .42rem;
        height: .46rem;
        margin-right: .1rem;
        vertical-align: text-bottom;
      }
    }
  }

  .content-container {
    margin-top: -1.7rem;
    .info {
      padding: 0.32rem 0.26rem;
      border-bottom: 1px solid #E5E5E5;
      display: flex;
      align-items: center;
      .line {
        width: 1px;
        height: 0.85rem;
        background: #E5E5E5;
        margin: 0 0.3rem;
      }
      .item {
        position: relative;
        line-height: 1.2;
        min-height: .89rem;
        .ic {
          position: absolute;
          right: 0;
          bottom: 0;
          width: .26rem;
          height: .26rem;
        }
        &.left {
          width: 3.7rem;
          .name {
            color: #2F2F2F;
            font-size: 0.38rem;
          }
        }
        &.right {
          flex: 1;
          color: #6C6C6C;
          font-size: 0.2rem;
          .name {
            color: #00D6C5;
            font-size: 0.38rem;
            margin-bottom: 0.05rem;
          }
        }
      }
    }
    .title {
      font-size: .24rem;
      padding: 0.18rem 0.24rem;
      color: #8B8B8B;
      .num {
        color: #00D6C5;
      }
    }
    .list {
      height: calc(100vh - 4rem);
      overflow: auto;
      .item {
        position: relative;
        width: 6.4rem;
        margin: 0 auto 0.2rem;
        .bg {
          width: 6.4rem;
          height: 3.2rem;
          object-fit: cover;
        }
        .main {
          position: absolute;
          left: 0;
          top: 0;
          width: 1.6rem;
          height: 100%;
          background: rgba(0, 0, 0, 0.65);
          color: #FFFFFF;
          padding: 0 0.25rem;
          line-height: 1.5;
          font-size: .23rem;
          .name {
            font-size: 0.36rem;
            padding: 0.4rem 0 0.2rem;
            border-bottom: 1px solid rgba(255,255,255,0.65);
            margin-bottom: 0.18rem;
          }
        }
      }
      .emptyListHint{
        text-align: center;
        padding: 1rem 0;
        color: #8b8b8b;
        img{
          width: 1rem;
        }
        div{
          margin: .25rem 0;
          &.txt1{
            color: #c3c3c3;
          }
        }

        .btn{
          position: relative;
          margin: .4rem auto 0;
          padding: .1rem;
          width: 2rem;
          border: #8b8b8b solid 1px;
          border-radius: 1rem;
          &:active{
            background: #fbfbfb;
          }
        }
      }
    }
    .type-img {
      width: 100%;
      height: auto;
      display: flex;
      margin: 2rem auto;
    }
  }
</style>
